import axios from 'axios'
window.gispai_baseURL = ""
window.gispai_token = ""
let service = axios.create({
  baseURL: gispai_baseURL,
  timeout: 30000
})
service.defaults.headers.common['Content-Type'] = 'application/json'

// request拦截器
service.interceptors.request.use(config => {
  config.headers.token = gispai_token
  return config
}, error => {
  Promise.reject(error)
})



service.interceptors.response.use(
  response => {
      if (response.status !== 200) {
          if (response.status === 403){
              Message.error('登录过期，请从新登录')
              localStorage.clear()
              store.commit('setTag', []);
              router.replace({
                  path: '/'
              })
          }
          return Promise.reject(response)
      } else {
        return response
      }
  },error => {
      return Promise.reject(error)
  }
);

export default service
